import {
  DashboardOutlined,
  DescriptionOutlined,
  WorkOutlineRounded,
  TaskAltRounded,
  PeopleAltOutlined,
  ForumOutlined,
  AssessmentOutlined,
  AdminPanelSettingsOutlined,
} from "@mui/icons-material";

/**
 * Main menu.
 *
 * IMPORTANT: each child's `name` is a PERMISSION KEY — it must match a module
 * name in the role's module list (getuserrolespecificmodules). Do not rename
 * them; to change the text users see, add a `label` instead.
 * `icon` is a component (rendered in the mobile navigation drawer).
 */
export const navigations = [
  {
    name: "Dashboard",
    icon: DashboardOutlined,
    type: "parent",
    children: [{ name: "Dashboard", path: "/dashboard", type: "child" }],
  },
  {
    name: "Document Management",
    icon: DescriptionOutlined,
    type: "parent",
    children: [
      { name: "Upload Document", path: "/convertdoc", type: "child" },
      { name: "View Documents", path: "/doctable", type: "child" },
    ],
  },
  {
    name: "Job Management",
    icon: WorkOutlineRounded,
    type: "parent",
    children: [
      { name: "Create Jobs", path: "/uploadjobs", type: "child" },
      { name: "View Jobs", path: "/viewjobs", type: "child" },
    ],
  },
  {
    name: "Task Management",
    icon: TaskAltRounded,
    type: "parent",
    children: [{ name: "View Tasks", path: "/viewtasks", type: "child" }],
  },
  {
    name: "User Management",
    icon: PeopleAltOutlined,
    type: "parent",
    children: [
      { name: "User Management", path: "/userdetails", type: "child" },
      { name: "User Modules", path: "/roles", type: "child" },
    ],
  },
  {
    name: "Requests",
    icon: ForumOutlined,
    type: "parent",
    children: [
      { name: "Requests", path: "/requests", type: "child" },
      { name: "Queries", path: "/queries", type: "child" },
    ],
  },
  {
    name: "Reports",
    icon: AssessmentOutlined,
    type: "parent",
    children: [
      { name: "Project Overview", path: "/projectstatus", type: "child" },
      { name: "Daily Status Report", path: "/dailystatus", type: "child" },
      { name: "Inputs Report", path: "/inputsreport", type: "child" },
      { name: "Inputs Summary", path: "/inputssummery", type: "child" },
      { name: "Outstanding Task", path: "/outstandingtask", type: "child" },
      { name: "Outputs Report", path: "/outputsreport", type: "child" },
      { name: "Outputs Report By Work Driver", path: "/outputsreportworkdriver", type: "child" },
      { name: "Week Wise Analysis Report", path: "/outputsreportgrapg", type: "child" },
      { name: "Outstanding Report", path: "/outstandsummery", type: "child" },
      { name: "Query Report", path: "/requestreport", type: "child" },
      { name: "Queries Summary", path: "/queriesreport", type: "child" },
      { name: "ProjVSRev Report", path: "/projvsrevreport", type: "child" },
      { name: "ProjVSAch Report", path: "/projvsachreport", type: "child" },
      { name: "Team Daily Status Report", path: "/teamDailySatus", type: "child" },
      { name: "Daily User Prod Report", path: "/dailyuserprodreport", type: "child" },
    ],
  },
  {
    name: "Admin",
    icon: AdminPanelSettingsOutlined,
    type: "parent",
    children: [
      { name: "Admin", path: "/admin", type: "child" },
      { name: "Delete Docs List", path: "/deletedocumets", type: "child" },
    ],
  },
];
